import {
  Button,
  CheckBox,
  DatePicker,
  Icon,
  RaytebForm,
  Select,
  TextBox,
  TypeaheadText,
} from '../../Elements'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import RaytebModal from './RaytebModal'
import useFetch from '../../../_services/fetch'
import { RaytebRequests } from '../../../_services'
import { useSelector } from 'react-redux'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import LoadingFit from '../Loading/LoadingFit'
import { useState, useEffect } from 'react'
import { toast } from 'react-toastify'

type VisitTimeType = {
  title: string
  selected: boolean
  index: number
}
type TimeType = {
  fromTime: string
  toTime: string
}
const UpdateDoctorTimeSheetModal = ({
  options,
  onSuccess,
  model,
}: {
  options: RaytebModalInterface
  onSuccess?: () => void
  model?: DoctorTimeSheetViewModel | undefined
}) => {
  var itemsDays = [
    { name: 'جمعه', id: 6 },
    { name: 'شنبه', id: 0 },
    { name: 'یکشنبه', id: 1 },
    { name: 'دوشنبه', id: 2 },
    { name: 'سه شنبه', id: 3 },
    { name: 'چهارشنبه', id: 4 },
    { name: 'پنجشنبه', id: 5 },
  ]
  var shifts = [
    { name: 'صبح', id: 1 },
    { name: 'ظهر', id: 2 },
    { name: 'شب', id: 3 },
  ]
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const updateDoctorTimeSheet = useFetch<
    unknown,
    DoctorTimeSheetUpdateInputModel
  >({
    request: RaytebRequests.DoctorTimeSheet_Update_Post({
      centerId: center.id!,
      token: user.token,
    }),
    onSuccess(data) {
      options.hideModal?.()
      toast.success('با موفقیت انجام شد')
      onSuccess?.()
    },
  })
  const getDoctorServes = useFetch<Array<DoctorServeViewModel>, unknown>({
    request: RaytebRequests.Doctor_GetDoctorServe_GET({
      centerId: center.id!,
      token: user.token,
    }),
    fetchInitialLoad: true,
  })
  const [doctorServe, setDoctorServe] = useState<DoctorServeViewModel | null>(
    null
  )
  const [listTimeVips, setListTimeVips] = useState<Array<VisitTimeType>>([])
  const [listTimeRefs, setListTimeRefs] = useState<Array<VisitTimeType>>([])
  const [visitTime, setVisitTime] = useState<TimeType>({
    fromTime: '',
    toTime: '',
  })
  const [restTime, setRestTime] = useState<TimeType>({
    fromTime: '',
    toTime: '',
  })
  const setDefualt = () => {
    setVisitTime({
      fromTime: model!.visitTime.split('-')[0],
      toTime: model!.visitTime.split('-')[1],
    })
    setRestTime({
      fromTime: model?.restTime?.split('-')[0] ?? '',
      toTime: model?.restTime?.split('-')[1] ?? '',
    })
  }
  const calcDate = (date1: Date, date2: Date): number => {
    var diff = Math.floor(date1.getTime() - date2.getTime())
    var min = 1000 * 60

    var minutes = Math.floor(diff / min)

    return minutes
  }
  const getTimes = (
    cap: number,
    fromTimeParam: string,
    toTimeParam: string,
    toTimeRestParam?: string,
    fromTimeRestParam?: string
  ): Array<VisitTimeType> => {
    const splitToTime = toTimeParam.split(':')
    const splitFromTime = fromTimeParam.split(':')
    const splitToTimeRest = toTimeRestParam?.split(':') ?? []
    const splitFromTimeRest = fromTimeRestParam?.split(':') ?? []
    const fromTime = new Date()
    fromTime.setHours(parseInt(splitFromTime[0]))
    fromTime.setMinutes(parseInt(splitFromTime[1]))
    const toTime = new Date()
    toTime.setHours(parseInt(splitToTime[0]))
    toTime.setMinutes(parseInt(splitToTime[1]))
    const toTimeRest = new Date()
    const fromTimeRest = new Date()

    if (toTimeRestParam && fromTimeRestParam) {
      toTimeRest.setHours(parseInt(splitToTimeRest?.[0] ?? 0))
      toTimeRest.setMinutes(parseInt(splitToTimeRest?.[1] ?? 0))
      fromTimeRest.setHours(parseInt(splitFromTimeRest[0]))
      fromTimeRest.setMinutes(parseInt(splitFromTimeRest[1]))
    }
    const dVisitMin = calcDate(toTime, fromTime)
    const dRestMin = calcDate(toTimeRest, fromTimeRest)


    const someTime = Math.round((dVisitMin - dRestMin) / cap)

    var times = Array<VisitTimeType>()
    times.push({
      title: `${('0' + fromTime.getHours()).substr(-2)}:${('0' + fromTime.getMinutes()).substr(-2)}`,
      selected: false,
      index: times.length + 1,
    })

    var index = 1
    var resultTime;
    while (times.length < cap) {
      const calTime = new Date(resultTime ?? fromTime)
      calTime.setMinutes(calTime.getMinutes() + (index * someTime))
      if (
        calTime >= fromTimeRest &&
        calTime <= toTimeRest
      ) {
        resultTime = toTimeRest;
        index = 1;
        addTime(resultTime, times);
        continue;
        // index += someTimeRest;
      }
      addTime(calTime, times);
      index += 1
    }
    return times
  }
  const addTime = (calTime: Date, times: Array<VisitTimeType>) => {
    const hour = '0' + calTime.getHours()
    const min = '0' + calTime.getMinutes()
    times.push({
      title: `${hour.substr(-2)}:${min.substr(-2)}`,
      selected: false,
      index: times.length + 1,
    })
  }
  const generateTimes = (fromTime, toTime) => {
    if (fromTime && toTime) {
      const cap = document.getElementById('Capacity') as HTMLInputElement
      var vips = getTimes(
        parseInt(cap.value),
        fromTime,
        toTime,
        restTime.toTime,
        restTime.fromTime
      )
      // listTimeVips.forEach((n, i) => {
      //   if (vips[i].title == n.title) vips[i].selected = true
      // })
      setListTimeVips(vips)

      var refs = getTimes(
        parseInt(cap.value),
        fromTime,
        toTime,
        restTime.toTime,
        restTime.fromTime
      )
      // listTimeRefs.forEach((n, i) => {
      //   if (refs[i].title == n.title) refs[i].selected = true
      // })
      setListTimeRefs(refs)
    }
  }

  useEffect(() => {
    if (model?.visitTime) {
      setVisitTime({
        fromTime: model!.visitTime.split('-')[0],
        toTime: model!.visitTime.split('-')[1],
      })
      setRestTime({
        fromTime: model?.restTime?.split('-')[0] ?? '',
        toTime: model?.restTime?.split('-')[1] ?? '',
      })
      setListTimeRefs(model?.tickets?.map((x, i) => { return { index: i + 1, title: x.ticketTime, selected: x.isRef } }) ?? [])
      setListTimeVips(model?.tickets?.map((x, i) => { return { index: i + 1, title: x.ticketTime, selected: x.isVip } }) ?? [])
    }
  }, [model])

  // useEffect(() => {
  //   if (visitTime.fromTime && visitTime.toTime) {
  //     var listRef = [...listTimeRefs]
  //     var listVips = [...listTimeVips]
  //     setListTimeRefs(listRef)
  //     setListTimeVips(listVips)
  //     generateTimes(visitTime.fromTime, visitTime.toTime)
  //   }
  // }, [visitTime])
  // useEffect(() => {
  //   if (restTime.fromTime && restTime.toTime) generateTimes(visitTime.fromTime, visitTime.toTime)
  // }, [restTime])
  useEffect(() => {
    if (model?.doctorServeId)
      setDoctorServe(
        getDoctorServes.result?.find((n) => n.id === model?.doctorServeId)!
      )
  }, [model?.doctorServeId])
  return (
    <RaytebModal {...options} hideModal={() => {
      setDefualt()
      options.hideModal?.()
    }} >
      <LoadingFit
        isLoading={getDoctorServes.isLoading || updateDoctorTimeSheet.isLoading}
      />
      <RaytebForm
        checkIsRequired={true}
        onSubmit={(e) => {
          updateDoctorTimeSheet.reFetch({
            capacity: e.target['capacity'].value,
            date: model?.visitDate!,
            fromTimeRest:
              e.target['fromTimeRest'].value === '__:__'
                ? null
                : e.target['fromTimeRest'].value,
            toTimeRest:
              e.target['toTimeRest'].value === '__:__'
                ? null
                : e.target['toTimeRest'].value,
            shift: e.target['shift'].value,
            day: itemsDays.find((n) => n.name === model?.day)?.id!,
            fromTimeVisit: e.target['fromTime'].value,
            toTimeVisit: e.target['toTime'].value,
            vipItemList: listTimeVips
              .filter((n) => n.selected)
              .map((n) => n.index)
              .toString(),
            refItemList: listTimeRefs
              .filter((n) => n.selected)
              .map((n) => n.index)
              .toString(),
            doctorServeId: doctorServe?.id!,
            id: model?.id!,
          })
        }}
      >
        <div className='grid grid-cols-2 gap-x-6 gap-y-8 px-6 py-8'>
          <TextBox
            value={itemsDays.find((n) => n.name === model?.day)?.name}
            innerText='روز'
            className='w-full'
            Type={TextBoxTypeEnum.Text} disabled={true} />

          <Select
            className='w-full'
            value={shifts.find((n) => n.name === model?.shift)?.id}
            name='shift'
            isRequired={true}
          >
            <option value={''}>انتخاب شیفت</option>
            {shifts.map((n, i) => (
              <option key={i} value={n.id}>
                {n.name}
              </option>
            ))}
          </Select>
          {getDoctorServes.isLoading ? (
            ''
          ) : (
            <TypeaheadText<DoctorServeViewModel>
              innerText='خدمت'
              fieldItem='title'
              fieldValue='id'
              value={getDoctorServes.result?.find(
                (n) => n.id === model?.doctorServeId
              )}
              selected={(e) => setDoctorServe(e)}
              listData={getDoctorServes.result}
              isRequired={true}
            ></TypeaheadText>
          )}

          <TextBox
            Type={TextBoxTypeEnum.Number}
            innerText='تعداد ظرفیت'
            className='w-full'
            value={model?.capacity.toString()}
            onChange={(e) => {
              var toTime = document.getElementById('ToTime') as HTMLInputElement
              var fromTime = document.getElementById(
                'FromTime'
              ) as HTMLInputElement
              if (toTime.value != '__:__' && fromTime.value != '__:__') generateTimes(fromTime.value, toTime.value)
            }}
            name='capacity'
            id='Capacity'
            isRequired={true}
          />
          {/* <DatePicker
            isRequired={true}
            value={
              model?.visitDate ? new Date(model?.visitDate).toShamsi() : ''
            }
            raytebValue={model?.visitDate ? model?.visitDate : new Date()}
            name='date'
            innerText='تاریخ'
            className='w-full'
          /> */}
          <TextBox
            className='w-full'
            isRequired={true}
            Regular='^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$'
            RxgMessage='از 00:00 تا 23:59'
            innerText='ساعت شروع'
            name='fromTime'
            id='FromTime'
            debounceTime={0}
            value={visitTime.fromTime}
            onChange={(e) => {
              var date = new Date()
              date.setHours(parseInt(e.target.value.split(':')[0]))
              date.setMinutes(parseInt(e.target.value.split(':')[1]))
              var time = new Date()
              time.setHours(parseInt(visitTime.toTime.split(':')[0]))
              time.setMinutes(parseInt(visitTime.toTime.split(':')[1]))
              if (date >= time) {
                toast.error(
                  'ساعت شروع  نمیتواند بزرگتر و مساوی ساعت پایان باشد'
                )
                return
              }

              setVisitTime({ ...visitTime, fromTime: e.target.value })
              var cap = document.getElementById('Capacity') as HTMLInputElement
              if (cap.value) generateTimes(e.target.value, visitTime.toTime)
            }}
            Type={TextBoxTypeEnum.Time}
          />
          <TextBox
            isRequired={true}
            Regular='^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$'
            RxgMessage='از 00:00 تا 23:59'
            className='w-full'
            innerText='ساعت پایان'
            name='toTime'
            value={visitTime.toTime}
            id='ToTime'
            debounceTime={0}
            onChange={(e) => {
              var date = new Date()
              date.setHours(parseInt(e.target.value.split(':')[0]))
              date.setMinutes(parseInt(e.target.value.split(':')[1]))
              var time = new Date()
              time.setHours(parseInt(visitTime.fromTime.split(':')[0]))
              time.setMinutes(parseInt(visitTime.fromTime.split(':')[1]))

              if (date <= time) {
                toast.error(
                  'ساعت پایان  نمیتواند کوچک تر و مساوی ساعت شروع باشد'
                )
                return
              }

              setVisitTime({ ...visitTime, toTime: e.target.value })
              var cap = document.getElementById('Capacity') as HTMLInputElement
              if (cap.value) generateTimes(visitTime.fromTime, e.target.value)
            }}
            Type={TextBoxTypeEnum.Time}
          />
          <TextBox
            className='w-full'
            Regular='^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$'
            RxgMessage={`از ${visitTime.fromTime} تا ${visitTime.toTime}`}
            innerText='شروع استراحت'
            disabled={!visitTime.fromTime}
            name='fromTimeRest'
            id='FromTimeRest'
            debounceTime={0}
            value={restTime.fromTime}
            onChange={(e) => {
              var date = new Date()
              date.setHours(parseInt(e.target.value.split(':')[0]))
              date.setMinutes(parseInt(e.target.value.split(':')[1]))
              var time = new Date()
              time.setHours(parseInt(visitTime.fromTime.split(':')[0]))
              time.setMinutes(parseInt(visitTime.fromTime.split(':')[1]))

              if (date <= time) {
                toast.error(
                  'ساعت شروع استراحت نمیتواند کوچک تر و مساوی ساعت شروع باشد'
                )
                return
              }

              setRestTime({ ...restTime, fromTime: e.target.value })
              var cap = document.getElementById('Capacity') as HTMLInputElement
              if (cap.value) generateTimes(visitTime.fromTime, visitTime.toTime)
            }}
            Type={TextBoxTypeEnum.Time}
          />
          <TextBox
            Regular='^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$'
            RxgMessage={`از ${visitTime.fromTime} تا ${visitTime.toTime}`}
            className='w-full'
            innerText='پایان استراحت'
            disabled={!visitTime.toTime}
            name='toTimeRest'
            value={restTime.toTime}
            id='ToTimeRest'
            debounceTime={0}
            onChange={(e) => {
              var date = new Date()
              date.setHours(parseInt(e.target.value.split(':')[0]))
              date.setMinutes(parseInt(e.target.value.split(':')[1]))
              var time = new Date()
              time.setHours(parseInt(visitTime.toTime.split(':')[0]))
              time.setMinutes(parseInt(visitTime.toTime.split(':')[1]))

              if (date >= time) {
                toast.error(
                  'ساعت شروع استراحت نمیتواند بزرگ تر و مساوی ساعت شروع باشد'
                )
                return
              }
              setRestTime({ ...restTime, toTime: e.target.value })
              var cap = document.getElementById('Capacity') as HTMLInputElement
              if (cap.value) generateTimes(visitTime.fromTime, visitTime.toTime)
            }}

            Type={TextBoxTypeEnum.Time}
          />
          <TextBox
            Type={TextBoxTypeEnum.Number}
            value={model?.refStartDay?.toString()}
            innerText='شروع ارجاع'
            className='w-full'
            disabled={true}
          />
          <TextBox
            Type={TextBoxTypeEnum.Number}
            value={model?.refExpireDay?.toString()}
            innerText='پایان ارجاع'
            className='w-full'
            disabled={true}

          />
        </div>
        <div className='w-full mt-2 flex justify-between items-center'>
          <div className='flex px-4 gap-1 items-center'>
            <Icon
              icon='rayteb-history-track'
              className='w-6 h-6 text-2xl text-primaryLight'
            />
            <span className='text-xs'>تیکت های VIP</span>
          </div>
          <div>
            <CheckBox
              disabled={listTimeVips.length === 0}
              id='ListTimeVipsCheck'
              onChange={(e) => {
                var list = [...listTimeVips]
                list.forEach((n, i) => {
                  if (!listTimeRefs[i].selected) n.selected = e.target.checked
                })
                setListTimeVips(list)

                if (
                  (
                    document.getElementById(
                      'ListTimeRefsCheck'
                    ) as HTMLInputElement
                  ).checked
                ) {
                  var list = [...listTimeRefs]
                  list.forEach((n, i) => {
                    if (!listTimeVips[i].selected) n.selected = true
                  })
                  setListTimeRefs(list)
                }
              }}
              lable='انتخاب همه'
              className='text-primaryLight text-xs'
            />
          </div>
        </div>

        <div className='grid grid-cols-6 gap-3  px-3 py-2'>
          {listTimeVips?.map((n, i) => (
            <Button
              key={i}
              onClick={() => {
                if (listTimeRefs[i].selected) {
                  toast.error('این زمان ارجاع میباشد')
                  return
                }
                var list = [...listTimeVips]
                list[i].selected = !list[i].selected
                setListTimeVips(list)
                if (
                  (
                    document.getElementById(
                      'ListTimeRefsCheck'
                    ) as HTMLInputElement
                  ).checked
                ) {
                  var list = [...listTimeRefs]
                  list.forEach((n, i) => {
                    if (!listTimeVips[i].selected) n.selected = true
                  })
                  setListTimeRefs(list)
                }
              }}
              className={`text-primaryLight bg-primaryDefault border-0 h-5 text-xs 
               ${n.selected
                  ? '!bg-warn !text-primaryDefault2 shadow-warnDark shadow-inner'
                  : 'font-bold'
                }`}
            >
              {`${n.title.toPersian()}`}
            </Button>
          ))}
        </div>

        <div className='w-full mt-3 flex justify-between items-center'>
          <div className='flex px-4 gap-1 items-center'>
            <Icon
              icon='rayteb-history-track'
              className='w-6 h-6 text-2xl text-primaryLight'
            />
            <span className='text-xs'>تیکت های ارجاع</span>
          </div>
          <div>
            <CheckBox
              disabled={listTimeRefs.length === 0}
              id='ListTimeRefsCheck'
              onChange={(e) => {
                var list = [...listTimeRefs]
                list.forEach((n, i) => {
                  if (!listTimeVips[i].selected) n.selected = e.target.checked
                })
                setListTimeRefs(list)

                if (
                  (
                    document.getElementById(
                      'ListTimeVipsCheck'
                    ) as HTMLInputElement
                  ).checked
                ) {
                  var list = [...listTimeVips]
                  list.forEach((n, i) => {
                    if (!listTimeRefs[i].selected) n.selected = true
                  })
                  setListTimeVips(list)
                }
              }}
              lable='انتخاب همه'
              className='text-primaryLight text-xs'
            />
          </div>
        </div>

        <div className='grid grid-cols-6 gap-3  px-3 py-2'>
          {listTimeRefs.map((n, i) => (
            <Button
              onClick={() => {
                if (listTimeVips[i].selected) {
                  toast.error('این زمان وی آی پی میباشد')
                  return
                }
                var list = [...listTimeRefs]
                list[i].selected = !list[i].selected
                setListTimeRefs(list)
                if (
                  (
                    document.getElementById(
                      'ListTimeVipsCheck'
                    ) as HTMLInputElement
                  ).checked
                ) {
                  var list = [...listTimeVips]
                  list.forEach((n, i) => {
                    if (!listTimeRefs[i].selected) n.selected = true
                  })
                  setListTimeVips(list)
                }
              }}
              key={i}
              className={`text-primaryLight bg-primaryDefault border-0 h-5 text-xs 
               ${n.selected
                  ? '!bg-secondaryLight !text-primaryDefault2 shadow-secondary shadow-inner'
                  : 'font-bold'
                }`}
            >
              {`${n.title.toPersian()}`}
            </Button>
          ))}
        </div>

        <div className='mt-4 flex justify-center items-center px-6 pb-3 gap-10 w-full'>
          <Button
            type='button'
            onClick={() => {
              setDefualt()
              options.hideModal?.()
            }}
            className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
          >
            انصراف
          </Button>
          <Button
            type='submit'
            className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
          >
            تایید
          </Button>
        </div>
      </RaytebForm>
    </RaytebModal>
  )
}

export default UpdateDoctorTimeSheetModal
